import React from "react"

// Views
import AppPanel from "@views/AppPanel"

// Components
import Headline from "@components/Headline"
import Typography from "@components/Typography"
import Metatags from "@components/Metatags"

// Material UI

import { makeStyles } from "@material-ui/core/styles"
const useStyles = makeStyles((theme) => ({}))

function FAQ(props) {
    const styles = useStyles()

    return (
        <AppPanel>
            <Metatags subtitle="SKIP/BBQ" path="faq" />
            <Headline>SKIP/BBQ</Headline>
            <center>
                <Typography variant="subtitle1">
                    Sadly there are more questions than answers...
                </Typography>
                <iframe
                    src="https://giphy.com/embed/OMeGDxdAsMPzW"
                    width="480"
                    height="362"
                    frameBorder="0"
                    allowFullScreen
                ></iframe>
            </center>
        </AppPanel>
    )
}

export default FAQ
